import PhoneAddressMixin, { getAddressPayload } from '../../../../partials/PhoneAddressEmail'
import { addDefaultClientReminders } from 'components/app/calendar/partials/mixins/remindersMixin'

function defaultTitleForClient (client) {
  return 'Job for ' + client.display_name
}

export default {
  mixins: [PhoneAddressMixin],
  methods: {
    /* When client is added to appointment, create default reminder (and prefill appropriate fields) */
    baseAddClient (model, client) {
      if (model.clients.find(item => item.id === client.id)) {
        return
      }

      model.clients.push(client)
      if (model.clients.length === 1) {
        this.baseFillClientDetails(model, client)
      }
      addDefaultClientReminders(model, client)
    },
    /* When client is removed from appointment */
    baseRemoveClient (model, client) {
      if (model.title === defaultTitleForClient(client)) {
        model.title = null
      }

      model.clients.splice(model.clients.map(item => item.id).indexOf(client.id), 1)
      model.client_reminders = model.client_reminders.filter(item => item.client_id !== client.id)
    },
    baseFillAddress (model, address) {
      if (!address) {
        return
      }

      model.address = getAddressPayload(false, address)
    },
    baseFillClientDetails (model, client) {
      const address = this.findAddress(client.addresses, 'STRUCTURE', 'SERVICE', 'PRIMARY', 'BILLING')
      if (!model.address && address) {
        this.baseFillAddress(model, address)
      }

      if (!model.title) {
        model.title = defaultTitleForClient(client)
      }

      if (client.timezone) {
        model.timezone = client.timezone
      }
    },
    /* Get an appropriate client field based on passed type */
    baseSelectAppropriateClientDetail (type, client) {
      if (type === 'EMAIL') {
        if (client.email_address) {
          return client.email_address
        }

        const email = this.findEmail(client.emails || [], 'PRIMARY', 'BILLING', 'EXTRA')
        if (email) {
          return email.email_address
        }
      }
      else if (type === 'SMS') {
        const phone = this.findPhone(client.phones || [], 'MOBILE', 'BUSINESS', 'DEFAULT')
        if (phone) {
          return phone.full_phone
        }
      }
      return null
    }
  }
}
